import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.hanscribe.interview.input');
import { OnInit, Input } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { hanscribeStatusBadgeClass } from "src/libs/portal/hanscribe/hanscribe";

type InterviewField = {
    key: string;
    label: string;
    rows: number;
    placeholder: string;
    section: string;
    required?: boolean;
};

@Component({
    selector: 'wiz-portal-hanscribe-interview-input',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.hanscribe.interview.input/view.scss */
:host {
  display: block;
  min-height: 100%;
}

.interview-input,
.interview-input * {
  box-sizing: border-box;
}

.interview-input {
  min-height: 100%;
  background: var(--hs-bg-page, #f6f8fb);
  color: var(--hs-text-strong, #111827);
  font-family: var(--hs-font-family-base, "SUIT", system-ui, sans-serif);
}

.interview-input.is-embedded {
  min-height: 0;
  background: transparent;
}

.interview-input.is-embedded .interview-shell {
  width: 100%;
  padding: 18px 20px 92px;
}

.interview-input.is-embedded .action-shell {
  width: 100%;
  padding-right: 20px;
  padding-left: 20px;
}

.interview-shell {
  width: min(100%, 980px);
  margin: 0 auto;
  padding: 28px 20px 104px;
}

.operator-nav {
  margin-bottom: 13px;
}

.back-button {
  display: inline-flex;
  min-height: 32px;
  align-items: center;
  gap: 7px;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: var(--hs-text-body, #334155);
  cursor: pointer;
  padding: 3px 7px 3px 1px;
  font-size: 13px;
  font-weight: 700;
}

.back-button span {
  color: var(--hs-text-muted, #64748b);
  font-size: 17px;
  font-weight: 500;
}

.back-button:hover {
  color: var(--hs-color-primary-700, #0f766e);
}

.back-button:focus-visible {
  outline: none;
  box-shadow: 0 0 0 3px var(--hs-focus-ring, rgba(13, 148, 136, 0.22));
}

.interview-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 16px;
}

.title-row {
  display: flex;
  align-items: center;
  gap: 10px;
}

.title-block h1 {
  margin: 0;
  font-size: 27px;
  font-weight: 800;
  letter-spacing: -0.025em;
  line-height: 1.25;
}

.input-mode {
  display: inline-flex;
  min-height: 24px;
  align-items: center;
  border: 1px solid var(--hs-color-primary-100, #cdeee8);
  border-radius: 5px;
  background: var(--hs-color-primary-50, #e8f7f4);
  color: var(--hs-color-primary-700, #0f766e);
  padding: 2px 7px;
  font-size: 11px;
  font-weight: 800;
  white-space: nowrap;
}

.title-block p {
  margin: 5px 0 0;
  color: var(--hs-text-muted, #64748b);
  font-size: 14px;
  line-height: 1.45;
}

.status-badge {
  display: inline-flex;
  min-height: 28px;
  align-items: center;
  border: 1px solid var(--hs-border-subtle, #dde3ea);
  border-radius: 999px;
  background: var(--hs-surface-muted, #eef2f6);
  color: var(--hs-text-body, #334155);
  padding: 3px 9px;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
}

.status-badge--primary,
.status-badge--success {
  border-color: var(--hs-color-success-100, #d1fae5);
  background: var(--hs-color-success-50, #ecfdf5);
  color: var(--hs-color-success-700, #047857);
}

.status-badge--warning,
.status-badge--pending,
.status-badge--draft {
  border-color: var(--hs-color-warning-100, #fef3c7);
  background: var(--hs-color-warning-50, #fffbeb);
  color: var(--hs-color-warning-700, #b45309);
}

.patient-summary {
  display: flex;
  align-items: stretch;
  border: 1px solid var(--hs-border-subtle, #dde3ea);
  border-radius: 12px 12px 0 0;
  background: #f9fbfa;
}

.patient-summary__person {
  display: flex;
  width: 220px;
  flex: 0 0 auto;
  flex-direction: column;
  justify-content: center;
  gap: 3px;
  border-right: 1px solid var(--hs-border-subtle, #dde3ea);
  padding: 15px 18px;
}

.patient-summary__person strong {
  font-size: 17px;
  font-weight: 800;
  line-height: 1.3;
}

.patient-summary__person span,
.patient-summary dt {
  color: var(--hs-text-muted, #64748b);
  font-size: 12px;
  font-weight: 650;
}

.patient-summary dl {
  display: grid;
  min-width: 0;
  flex: 1;
  grid-template-columns: 1.5fr 1fr 0.8fr;
  margin: 0;
}

.patient-summary dl > div {
  display: flex;
  min-width: 0;
  flex-direction: column;
  justify-content: center;
  gap: 4px;
  padding: 13px 16px;
}

.patient-summary dd {
  margin: 0;
  color: var(--hs-text-body, #334155);
  font-size: 14px;
  font-weight: 700;
  line-height: 1.4;
  overflow-wrap: anywhere;
}

.interview-form {
  overflow: hidden;
  border: 1px solid var(--hs-border-subtle, #dde3ea);
  border-top: 0;
  border-radius: 0 0 12px 12px;
  background: #ffffff;
  box-shadow: 0 6px 18px rgba(15, 23, 42, 0.035);
}

.completion-panel {
  display: flex;
  min-height: 260px;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  border: 1px solid var(--hs-border-subtle, #dde3ea);
  border-top: 0;
  border-radius: 0 0 12px 12px;
  background: #ffffff;
  padding: 40px 24px;
  text-align: center;
}

.completion-check {
  display: inline-flex;
  width: 46px;
  height: 46px;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: var(--hs-color-primary-50, #e8f7f4);
  color: var(--hs-color-primary-700, #0f766e);
  font-size: 21px;
  font-weight: 800;
}

.completion-panel h2 {
  margin: 18px 0 0;
  font-size: 21px;
  font-weight: 800;
  letter-spacing: -0.02em;
  line-height: 1.35;
}

.completion-panel p {
  max-width: 470px;
  margin: 8px 0 0;
  color: var(--hs-text-body, #334155);
  font-size: 14px;
  line-height: 1.55;
}

.completion-panel small {
  margin-top: 6px;
  color: var(--hs-text-muted, #64748b);
  font-size: 12px;
}

.completion-actions {
  display: flex;
  gap: 8px;
  margin-top: 24px;
}

.form-section {
  padding: 24px;
}

.form-section + .form-section {
  border-top: 1px solid #e7ebef;
}

.form-section--history {
  background: #fcfdfc;
}

.section-heading-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
}

.section-title {
  margin-bottom: 14px;
}

.section-title h2 {
  margin: 0;
  font-size: 17px;
  font-weight: 800;
  letter-spacing: -0.01em;
  line-height: 1.35;
}

.section-title p {
  margin: 4px 0 0;
  color: var(--hs-text-muted, #64748b);
  font-size: 12px;
  line-height: 1.45;
}

.symptom-grid,
.history-grid {
  display: grid;
  gap: 14px;
}

.symptom-grid {
  grid-template-columns: minmax(0, 0.85fr) minmax(0, 1.35fr);
}

.history-grid {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.field {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 7px;
}

.field-heading,
.field-label {
  display: flex;
  align-items: center;
}

.field-heading {
  min-height: 28px;
  justify-content: space-between;
  gap: 8px;
}

.field-label {
  min-height: 23px;
  gap: 7px;
  color: var(--hs-text-body, #334155);
  font-size: 14px;
  font-weight: 750;
}

.field-label em {
  border-radius: 4px;
  background: var(--hs-color-primary-50, #e8f7f4);
  color: var(--hs-color-primary-700, #0f766e);
  padding: 2px 5px;
  font-size: 10px;
  font-style: normal;
  font-weight: 800;
}

.quick-none,
.quick-all {
  border: 1px solid var(--hs-border-strong, #c7d0da);
  border-radius: 6px;
  background: #ffffff;
  color: var(--hs-text-muted, #64748b);
  cursor: pointer;
  font-size: 11px;
  font-weight: 700;
}

.quick-none {
  height: 27px;
  padding: 0 8px;
}

.quick-all {
  min-height: 32px;
  padding: 0 10px;
  font-size: 12px;
}

.quick-none:hover:not(:disabled),
.quick-all:hover:not(:disabled) {
  border-color: #78afa2;
  color: var(--hs-color-primary-700, #0f766e);
}

.quick-none.is-active,
.quick-all.is-active {
  border-color: #9bcfc3;
  background: var(--hs-color-primary-50, #e8f7f4);
  color: var(--hs-color-primary-700, #0f766e);
}

.quick-none:focus-visible,
.quick-all:focus-visible,
.button:focus-visible {
  outline: none;
  box-shadow: 0 0 0 3px var(--hs-focus-ring, rgba(13, 148, 136, 0.22));
}

.text-area {
  width: 100%;
  min-height: 96px;
  border: 1px solid var(--hs-border-strong, #c7d0da);
  border-radius: 8px;
  background: #ffffff;
  color: var(--hs-text-strong, #111827);
  padding: 11px 12px;
  font-family: inherit;
  font-size: 15px;
  line-height: 1.5;
  outline: none;
  resize: vertical;
  transition: border-color 140ms ease, box-shadow 140ms ease;
}

.text-area[rows="4"] {
  min-height: 116px;
}

.text-area--compact {
  min-height: 82px;
  font-size: 14px;
}

.text-area--memo {
  min-height: 78px;
}

.text-area:hover:not(:disabled) {
  border-color: #aab6af;
}

.text-area:focus {
  border-color: var(--hs-color-primary-700, #0f766e);
  box-shadow: 0 0 0 3px var(--hs-focus-ring, rgba(13, 148, 136, 0.22));
}

.text-area:disabled,
.quick-none:disabled,
.quick-all:disabled {
  cursor: not-allowed;
  background: var(--hs-surface-muted, #eef2f6);
  color: var(--hs-text-disabled, #94a3b8);
}

.interview-input textarea::placeholder {
  color: #94a3b8;
}

.alert,
.loading-panel {
  margin-bottom: 12px;
  border: 1px solid var(--hs-border-subtle, #dde3ea);
  border-radius: 9px;
  background: #ffffff;
}

.alert {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 12px;
  padding: 12px 14px;
  font-size: 13px;
}

.alert-error {
  border-color: var(--hs-color-danger-100, #fee2e2);
  background: var(--hs-color-danger-50, #fef2f2);
  color: var(--hs-color-danger-700, #b91c1c);
}

.loading-panel {
  display: flex;
  min-height: 240px;
  align-items: center;
  justify-content: center;
  color: var(--hs-text-muted, #64748b);
  font-size: 14px;
  font-weight: 700;
}

.debug-section {
  display: grid;
  gap: 8px;
  margin: 10px 0;
}

.debug-toggle {
  width: fit-content;
  border: 0;
  background: transparent;
  color: inherit;
  cursor: pointer;
  padding: 0;
  font-size: 11px;
  font-weight: 700;
  text-decoration: underline;
  text-underline-offset: 3px;
}

.debug-detail {
  display: grid;
  gap: 6px;
  border: 1px dashed #cbd5e1;
  border-radius: 7px;
  background: #f8fafc;
  padding: 9px;
}

.debug-detail--grid {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.debug-detail > div {
  display: grid;
  min-width: 0;
  gap: 2px;
}

.debug-detail span,
.debug-detail code {
  font-size: 11px;
  overflow-wrap: anywhere;
}

.action-bar {
  position: sticky;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 10;
  border-top: 1px solid var(--hs-border-subtle, #dde3ea);
  background: rgba(255, 255, 255, 0.96);
  backdrop-filter: blur(10px);
}

.action-shell {
  display: flex;
  width: min(100%, 980px);
  min-height: 68px;
  margin: 0 auto;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 10px 20px;
}

.completion-state {
  display: flex;
  align-items: baseline;
  gap: 8px;
  color: var(--hs-color-warning-700, #b45309);
}

.completion-state--ready {
  color: var(--hs-color-primary-700, #0f766e);
}

.completion-state strong {
  font-size: 13px;
  font-weight: 800;
}

.completion-state span {
  color: var(--hs-text-muted, #64748b);
  font-size: 11px;
  font-weight: 600;
}

.action-buttons {
  display: flex;
  gap: 8px;
}

.action-buttons--single {
  grid-template-columns: 1fr;
}

.button {
  display: inline-flex;
  min-width: 102px;
  height: 40px;
  align-items: center;
  justify-content: center;
  border: 1px solid transparent;
  border-radius: 7px;
  padding: 0 14px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 750;
  white-space: nowrap;
}

.button--secondary {
  border-color: var(--hs-btn-secondary-border, #c7d0da);
  background: var(--hs-btn-secondary-bg, #ffffff);
  color: var(--hs-btn-secondary-text, #334155);
}

.button--secondary:hover:not(:disabled) {
  background: var(--hs-btn-secondary-bg-hover, #f6f8fb);
}

.button--primary {
  min-width: 118px;
  background: var(--hs-btn-primary-bg, #0f766e);
  color: #ffffff;
}

.button--primary:hover:not(:disabled) {
  background: var(--hs-btn-primary-bg-hover, #0d9488);
}

.button:disabled {
  border-color: var(--hs-border-subtle, #dde3ea);
  background: var(--hs-surface-muted, #eef2f6);
  color: var(--hs-text-disabled, #94a3b8);
  cursor: not-allowed;
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  clip-path: inset(50%);
  white-space: nowrap;
}

@media (max-width: 760px) {
  .interview-input.is-embedded .interview-shell {
    padding: 14px 14px 92px;
  }
  .interview-input.is-embedded .action-shell {
    padding-right: 14px;
    padding-left: 14px;
  }
  .interview-shell {
    padding: 20px 14px 104px;
  }
  .patient-summary {
    display: block;
  }
  .patient-summary__person {
    width: auto;
    border-right: 0;
    border-bottom: 1px solid var(--hs-border-subtle, #dde3ea);
  }
  .patient-summary dl {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .patient-summary dl > div:last-child {
    grid-column: 1/-1;
  }
  .symptom-grid,
  .history-grid {
    grid-template-columns: 1fr;
  }
  .form-section {
    padding: 20px 16px;
  }
  .action-shell {
    padding-right: 14px;
    padding-left: 14px;
  }
}
@media (max-width: 520px) {
  .interview-header {
    align-items: flex-start;
    flex-direction: column;
    gap: 10px;
  }
  .title-block h1 {
    font-size: 24px;
  }
  .input-mode {
    min-height: 22px;
  }
  .status-badge {
    min-height: 26px;
  }
  .section-heading-row {
    align-items: stretch;
    flex-direction: column;
    gap: 0;
  }
  .quick-all {
    width: 100%;
    margin: -2px 0 14px;
  }
  .text-area {
    font-size: 16px;
  }
  .debug-detail--grid {
    grid-template-columns: 1fr;
  }
  .action-shell {
    align-items: stretch;
    flex-direction: column;
    gap: 8px;
    padding-top: 9px;
    padding-bottom: 9px;
  }
  .completion-state {
    justify-content: space-between;
  }
  .action-buttons {
    display: grid;
    grid-template-columns: minmax(0, 0.8fr) minmax(0, 1.2fr);
  }
  .action-buttons.action-buttons--single {
    grid-template-columns: 1fr;
  }
  .completion-panel {
    min-height: 240px;
    padding: 34px 18px;
  }
  .completion-actions {
    display: grid;
    width: 100%;
    grid-template-columns: 1fr;
  }
  .completion-actions .button {
    width: 100%;
  }
  .button,
  .button--primary {
    width: 100%;
    min-width: 0;
    height: 44px;
  }
}
@media (prefers-reduced-motion: reduce) {
  .interview-input *,
  .interview-input *::before,
  .interview-input *::after {
    scroll-behavior: auto !important;
    transition-duration: 0.01ms !important;
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
  }
}`],
})
export class PortalHanscribeInterviewInputComponent implements OnInit {
    @Input() context: any;

    public componentId = 'interview.input';
    public loading = true;
    public saving = false;
    public submitting = false;
    public dirty = false;
    public error = '';
    public requestId = '';
    public lastSavedAt = '';
    public status = 'draft';
    public debugDetailsOpen = false;
    public editingSubmitted = false;

    public bundleId = '';
    public patientId = '';
    public encounterId = '';
    public sourceChannel = 'operator';
    private precheckToken = '';
    public patient: any = {};
    public encounter: any = {};

    public fields: InterviewField[] = [
        {
            key: 'chief_complaint',
            label: '가장 불편한 증상',
            rows: 2,
            placeholder: '예: 허리가 아파요, 식후에 속이 더부룩해요',
            section: 'required',
            required: true,
        },
        {
            key: 'symptom_detail',
            label: '불편한 양상과 경과',
            rows: 4,
            placeholder: '언제 시작됐는지, 얼마나 불편한지, 심해지거나 나아지는 상황을 적어주세요',
            section: 'symptom',
        },
        {
            key: 'past_history',
            label: '질환·수술 이력',
            rows: 3,
            placeholder: '진단받은 질환이나 수술·입원 이력',
            section: 'history',
        },
        {
            key: 'medication',
            label: '복용 중인 약',
            rows: 3,
            placeholder: '약 이름 또는 복용 목적, 건강기능식품',
            section: 'history',
        },
        {
            key: 'allergy',
            label: '알레르기',
            rows: 3,
            placeholder: '약물, 음식 등 알레르기',
            section: 'history',
        },
        {
            key: 'memo',
            label: '특이사항',
            rows: 3,
            placeholder: '임신·수유, 생활 습관 등 진료 전에 알릴 내용',
            section: 'memo',
        },
    ];

    public form: any = {
        chief_complaint: '',
        symptom_detail: '',
        past_history: '',
        medication: '',
        allergy: '',
        memo: '',
    };

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        this.resolveContext();
        await this.loadState();
    }

    public get busy() {
        return this.loading || this.saving || this.submitting;
    }

    public get isOperatorMode() {
        return this.sourceChannel !== 'patient';
    }

    public get embedded() {
        return !!(this.context && (this.context.embedded === true || this.context.embedded === 'true'));
    }

    public get inputModeLabel() {
        if (this.sourceChannel === 'doctor') return '의료진 입력';
        if (this.sourceChannel === 'admin') return '관리자 입력';
        return '원무 입력';
    }

    public get showOperatorCompletion() {
        return this.isOperatorMode
            && this.status === 'submitted'
            && !this.dirty
            && !this.editingSubmitted;
    }

    public get symptomFields() {
        return this.fields.filter((field) => field.section === 'required' || field.section === 'symptom');
    }

    public get historyFields() {
        return this.fields.filter((field) => field.section === 'history');
    }

    public get memoFields() {
        return this.fields.filter((field) => field.section === 'memo');
    }

    public get answeredCount() {
        return this.fields.filter((field) => String(this.form[field.key] || '').trim() !== '').length;
    }

    public get canSubmit() {
        return String(this.form.chief_complaint || '').trim() !== '';
    }

    public get allHistoryNone() {
        return this.historyFields.length > 0
            && this.historyFields.every((field) => this.form[field.key] === '없음');
    }

    public get completionLabel() {
        if (!this.canSubmit) return '주요 증상 입력 필요';
        if (this.status === 'submitted' && !this.dirty) return '제출 완료';
        return '제출 가능';
    }

    public get submitButtonLabel() {
        if (this.status === 'submitted' && !this.dirty) return '제출 완료';
        if (this.status === 'submitted') return '수정 제출';
        return '예진 제출';
    }

    public get submittedAtLabel() {
        if (!this.lastSavedAt) return '';
        return this.formatDateTime(this.lastSavedAt);
    }

    public get statusLabel() {
        if (this.submitting) return '제출 중';
        if (this.saving) return '저장 중';
        if (this.status === 'submitted' && this.dirty) return '수정 중';
        if (this.status === 'submitted') return '제출 완료';
        if (this.dirty) return '작성 중';
        if (this.lastSavedAt) return '임시 저장됨';
        return '작성 전';
    }

    public get statusBadgeClass() {
        if (this.status === 'submitted' && !this.dirty) return hanscribeStatusBadgeClass('submitted', 'precheck', 'status-badge');
        if (this.dirty) return hanscribeStatusBadgeClass('draft', 'precheck', 'status-badge');
        return hanscribeStatusBadgeClass('pending', 'precheck', 'status-badge');
    }

    public get canViewDebugDetails() {
        return this.isDevMode() || this.queryValue('debug') === '1';
    }

    public get patientDisplayName() {
        return this.displayValue(this.patient && this.patient.display_name, '환자 정보 확인 중');
    }

    public get patientBirthSex() {
        const birthValue = this.patient && this.patient.birth_date;
        const birth = birthValue ? this.formatDate(birthValue) : '생년월일 없음';
        const sex = this.sexLabel(this.patient && this.patient.sex_code);
        return `${birth} / ${sex}`;
    }

    public get scheduledAt() {
        const value = this.encounter && this.encounter.scheduled_at;
        return value ? this.formatDateTime(value) : '예약일시 없음';
    }

    public get assignedPerson() {
        return this.displayValue(this.encounter && this.encounter.assigned_doctor_name, '담당자 없음');
    }

    public get roomCode() {
        return this.displayValue(this.encounter && this.encounter.room_code, '진료실 미정');
    }

    public markDirty() {
        if (this.status === 'submitted') this.editingSubmitted = true;
        this.dirty = true;
        this.error = '';
        this.notifyDirtyChange();
    }

    public async setQuickValue(key: string, value: string) {
        if (this.busy || this.form[key] === undefined) return;
        this.form[key] = this.form[key] === value ? '' : value;
        this.markDirty();
        await this.service.render();
    }

    public async setAllHistoryNone() {
        if (this.busy) return;
        const value = this.allHistoryNone ? '' : '없음';
        this.historyFields.forEach((field) => {
            this.form[field.key] = value;
        });
        this.markDirty();
        await this.service.render();
    }

    public async toggleDebugDetails() {
        if (!this.canViewDebugDetails) return;
        this.debugDetailsOpen = !this.debugDetailsOpen;
        await this.service.render();
    }

    public async backToBoard() {
        if (this.embedded) {
            await this.invokeContextCallback('onClose');
            return;
        }
        if (this.dirty && !this.confirmDiscardChanges()) return;
        this.service.href('/hanscribe/encounters');
    }

    public async editSubmitted() {
        this.editingSubmitted = true;
        await this.service.render();
        this.focusField('chief_complaint');
    }

    public async loadState() {
        this.loading = true;
        this.error = '';
        await this.service.render();

        const result = await this.callApi('load_state', {
            bundle_id: this.bundleId,
            patient_id: this.patientId,
            encounter_id: this.encounterId,
        });

        this.loading = false;
        if (result.ok) {
            const state = result.data && result.data.state ? result.data.state : result.data;
            this.applyState(state);
            this.dirty = false;
            this.editingSubmitted = false;
            this.notifyDirtyChange();
        } else {
            this.error = result.message;
        }
        await this.service.render();
    }

    public async saveDraft() {
        this.saving = true;
        this.error = '';
        await this.service.render();

        const result = await this.callApi('save_draft', this.buildPayload());
        this.saving = false;

        if (result.ok) {
            this.applyState(result.data && result.data.result ? result.data.result : result.data);
            this.dirty = false;
            this.notifyDirtyChange();
        } else {
            this.error = result.message;
        }
        await this.service.render();
    }

    public async submit() {
        if (!this.canSubmit) {
            this.error = '주요 증상을 입력해주세요.';
            await this.service.render();
            this.focusField('chief_complaint');
            return;
        }

        this.submitting = true;
        this.error = '';
        await this.service.render();

        const result = await this.callApi('submit', this.buildPayload());
        this.submitting = false;

        if (result.ok) {
            this.applyState(result.data && result.data.result ? result.data.result : result.data);
            this.dirty = false;
            this.editingSubmitted = false;
            this.notifyDirtyChange();
            if (this.embedded && await this.invokeContextCallback('onSubmitted')) return;
        } else {
            this.error = result.message;
        }
        await this.service.render();
    }

    private resolveContext() {
        this.bundleId = this.contextValue('bundle_id') || this.queryValue('bundle_id');
        this.patientId = this.contextValue('patient_id') || this.queryValue('patient_id');
        this.encounterId = this.contextValue('encounter_id') || this.queryValue('encounter_id');
        this.precheckToken = this.contextValue('precheck_token') || this.queryValue('token');
        this.sourceChannel = this.precheckToken
            ? 'patient'
            : (this.contextValue('source_channel') || this.queryValue('source_channel') || 'operator');
    }

    private notifyDirtyChange() {
        if (!this.context || typeof this.context.onDirtyChange !== 'function') return;
        try {
            this.context.onDirtyChange(this.dirty);
        } catch (e) {
            // Parent notifications are optional outside the embedded operator flow.
        }
    }

    private async invokeContextCallback(name: string) {
        if (!this.context || typeof this.context[name] !== 'function') return false;
        try {
            await this.context[name]();
            return true;
        } catch (e) {
            return false;
        }
    }

    private contextValue(key: string) {
        if (!this.context || typeof this.context !== 'object') return '';
        if (this.context[key]) return String(this.context[key]);
        if (this.context.interview && this.context.interview[key]) return String(this.context.interview[key]);
        if (this.context.encounter && this.context.encounter[key]) return String(this.context.encounter[key]);
        if (this.context.patient && key === 'patient_id' && this.context.patient.id) return String(this.context.patient.id);
        return '';
    }

    private queryValue(key: string) {
        try {
            const params = new URLSearchParams(window.location.search || '');
            return params.get(key) || '';
        } catch (e) {
            return '';
        }
    }

    private buildPayload() {
        return {
            bundle_id: this.bundleId,
            patient_id: this.patientId,
            encounter_id: this.encounterId,
            source_channel: this.sourceChannel,
            responses: JSON.stringify(this.toResponses()),
            bundle_meta: JSON.stringify({
                component: this.componentId,
                flow: 'W01',
                entry_mode: this.isOperatorMode ? 'operator' : 'patient',
            }),
        };
    }

    private toResponses() {
        return this.fields.map((field) => ({
            item_code: field.key,
            label: field.label,
            response_type: 'text',
            value: this.form[field.key] || '',
        }));
    }

    private applyState(state: any) {
        if (!state) return;
        const bundle = state.bundle || {};
        this.patient = state.patient || this.patient || {};
        this.encounter = state.encounter || this.encounter || {};
        this.bundleId = state.bundle_id || bundle.id || this.bundleId;
        this.patientId = state.patient_id || bundle.patient_id || this.patientId;
        this.encounterId = state.encounter_id || bundle.encounter_id || this.encounterId;
        this.sourceChannel = this.sourceChannel || bundle.source_channel || 'operator';
        this.status = state.status === 'submitted' || bundle.status === 'submitted' ? 'submitted' : 'draft';
        this.lastSavedAt = bundle.submitted_at || bundle.updated || this.lastSavedAt;

        const responses = state.responses || [];
        responses.forEach((row) => {
            const rawValue = row.raw_value && typeof row.raw_value === 'object' ? row.raw_value : {};
            if (row.item_code && this.form[row.item_code] !== undefined) {
                this.form[row.item_code] = row.display_text || rawValue.value || '';
            }
        });
    }

    private displayValue(value: any, fallback: string = '-') {
        if (value === null || value === undefined || value === '') return fallback;
        return String(value);
    }

    private formatDate(value: any) {
        const text = String(value || '').trim();
        const match = text.match(/^(\d{4})-(\d{2})-(\d{2})/);
        if (!match) return text || '-';
        return `${match[1]}. ${match[2]}. ${match[3]}.`;
    }

    private formatDateTime(value: any) {
        const text = String(value || '').trim();
        const match = text.match(/^(\d{4})-(\d{2})-(\d{2})[T\s](\d{2}):(\d{2})/);
        if (!match) return text || '-';
        return `${match[1]}. ${match[2]}. ${match[3]}. ${match[4]}:${match[5]}`;
    }

    private focusField(id: string) {
        setTimeout(() => {
            try {
                const element = document.getElementById(id) as HTMLElement;
                if (element) {
                    element.focus();
                    element.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
            } catch (e) {
                // Browser focus support is optional in embedded/test environments.
            }
        }, 0);
    }

    private confirmDiscardChanges() {
        try {
            return window.confirm('저장하지 않은 입력 내용이 있습니다. 환자·방문 보드로 돌아갈까요?');
        } catch (e) {
            return false;
        }
    }

    private sexLabel(value: string) {
        const labels: any = {
            F: '여',
            M: '남',
            U: '미상',
        };
        return labels[value] || value || '성별 없음';
    }

    private isDevMode() {
        try {
            return document.cookie.split(';').some((item) => item.trim() === 'season-wiz-devmode=true')
                || window.localStorage.getItem('hanscribe_debug') === 'true';
        } catch (e) {
            return false;
        }
    }

    private async callApi(action: string, payload: any) {
        try {
            const route = this.precheckRoute(action);
            if (route) {
                const params = new URLSearchParams();
                Object.keys(payload || {}).forEach((key) => {
                    const value = payload[key];
                    if (value !== undefined && value !== null) params.set(key, String(value));
                });
                const url = `/api/hanscribe/precheck/${route}?${params.toString()}`;
                const headers: any = {};
                if (this.precheckToken) headers.Authorization = `Bearer ${this.precheckToken}`;
                const response = await fetch(url, {
                    method: action === 'load_state' ? 'GET' : 'POST',
                    credentials: 'same-origin',
                    headers,
                });
                return this.unwrapResponse(await response.json());
            }
            const response: any = await wiz.call(action, payload);
            const result = this.unwrapResponse(response);
            this.requestId = result.requestId || this.requestId;
            return result;
        } catch (e) {
            return { ok: false, data: null, requestId: '', message: '요청 처리 중 오류가 발생했습니다.' };
        }
    }

    private precheckRoute(action: string) {
        const routes: any = {
            load_state: 'state',
            save_draft: 'save_draft',
            submit: 'submit',
        };
        return routes[action] || '';
    }

    private unwrapResponse(response: any) {
        const payload = response && response.responseJSON ? response.responseJSON : response;
        const nested = payload && payload.data && payload.data.ok !== undefined ? payload.data : payload;
        const requestId = nested && nested.request_id ? nested.request_id : '';

        if (nested && nested.ok === true) {
            return { ok: true, data: nested.data || {}, requestId, message: '' };
        }

        if (payload && payload.code === 200) {
            return { ok: true, data: payload.data || {}, requestId, message: '' };
        }

        const error = nested && nested.error ? nested.error : null;
        const message = error && error.message ? error.message : '요청을 완료하지 못했습니다.';
        return { ok: false, data: null, requestId, message };
    }
}

export default PortalHanscribeInterviewInputComponent;